// Mock data for Legal Brand Hub clone

export const services = [
  {
    id: 'trademark',
    title: 'Trademark Registration',
    description: 'Secure your brand identity with expert USPTO trademark registration. Protect your business name, logo, and slogan from competitors nationwide.',
    icon: 'Shield',
    link: '/services/trademark'
  },
  {
    id: 'copyright',
    title: 'Copyright Registration',
    description: 'Safeguard your creative works, digital content, and original materials with federal copyright protection. Fast filing with experienced IP attorneys.',
    icon: 'FileText',
    link: '/services/copyright'
  },
  {
    id: 'patent',
    title: 'Patent Services',
    description: 'Turn innovations into protected assets. Comprehensive patent search, utility patent filing, and design patent services for inventors and businesses.',
    icon: 'Lightbulb',
    link: '/services/patent'
  },
  {
    id: 'company',
    title: 'Company Formation',
    description: 'Launch your business right. Expert LLC formation, C-Corp, S-Corp, and Non-Profit entity setup with complete legal compliance.',
    icon: 'Building',
    link: '/services/company-formation'
  }
];

export const pricingPlans = [
  {
    id: 'essentials',
    name: 'Essentials',
    price: 49,
    popular: false,
    description: 'Perfect for first-time trademark filers',
    features: [
      'Case Review & Assessment',
      'Basic Trademark Search',
      'USPTO Filing Assistance',
      'Trademark Monitoring (1 Month)',
      'Email Support',
      'Attorney Pre-Filing Letter',
      'Trademark Secured'
    ]
  },
  {
    id: 'standard',
    name: 'Standard',
    price: 149,
    popular: true,
    description: 'Ideal for growing businesses',
    features: [
      'Everything in Essentials',
      'Expert Case Review',
      'Comprehensive Trademark Search',
      'Trademark Monitoring (3 Months)',
      'Risk Evaluation Report',
      'Cease & Desist Template',
      'Dedicated Account Manager',
      '100% Approval Guarantee'
    ]
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 299,
    popular: false,
    description: 'Complete protection for established brands',
    features: [
      'Everything in Standard',
      'Attorney Review & Filing',
      '24-Hour Expedited Processing',
      'Trademark Monitoring (12 Months)',
      'Comprehensive Search (50 States)',
      'Office Action Support',
      'Opposition & Litigation Advice',
      '100% Approval Guarantee'
    ]
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 899,
    popular: false,
    description: 'Maximum protection & premium service',
    features: [
      'Everything in Professional',
      'Direct Attorney Assignment',
      'Trademark Monitoring (24 Months)',
      'International Trademark Support',
      '24/7 Secure Portal Access',
      'Complete Opposition Management',
      'White Glove Service',
      '100% Approval Guarantee'
    ]
  }
];

export const lpPricingPlans = [
  {
    id: 'essentials',
    name: 'Essentials',
    price: 45,
    popular: false,
    description: 'Basic trademark filing service',
    features: [
      'Case Review',
      'Basic Trademark Search',
      'Trademark Secured',
      '24/7 Secure Online Access',
      'Cease & Desist Letter Template',
      'Free Infringement Alerts (1 Month)'
    ]
  },
  {
    id: 'enhanced',
    name: 'Enhanced',
    price: 149,
    popular: true,
    description: 'Enhanced filing with comprehensive search',
    features: [
      'Case Review by TM Expert',
      'Trademark Monitoring (3 Months)',
      '24-Hour Expedited Processing',
      'Trademark Secured',
      'Attorney Pre-Filing Letter',
      'Free Infringement Alerts (1 Month)',
      'Dedicated Client Relations Attorney'
    ]
  },
  {
    id: 'elite',
    name: 'Elite',
    price: 299,
    popular: false,
    description: 'Comprehensive filing with full legal support',
    features: [
      'Attorney Case Review & Filing',
      'Trademark Monitoring (12 Months)',
      'Direct Hit Search',
      'Refusal Risk Evaluation',
      'Comprehensive Search (50 States + Social Media/Domains)',
      'Litigant Scan',
      'Opposition & Litigation Support',
      'Dedicated Attorney',
      '100% Approval Guaranteed'
    ]
  },
  {
    id: 'exclusive',
    name: 'Exclusive',
    price: 899,
    popular: false,
    description: 'The most comprehensive trademark protection',
    features: [
      'Everything in Elite',
      'Trademark Monitoring (12 Months)',
      'Complete Paperwork Filing',
      'International Trademark Assistance',
      'Global Risk Assessment (100+ Countries)',
      'Free Infringement Alerts (3 Months)',
      'Priority Legal Support',
      '100% Approval Guarantee'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    role: 'Entrepreneur, Wellness Co.',
    image: 'https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg',
    content: 'I needed comprehensive trademark monitoring for my growing wellness brand. Our Team\'s proactive approach caught potential conflicts early and saved me from costly disputes. Invaluable service!'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'CEO, TechNova Solutions',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Our Team made our brand registration process seamless. Their attention to detail and expert guidance gave us complete confidence in protecting our intellectual property. Highly recommend their services!'
  },
  {
    id: 3,
    name: 'Marcus Johnson',
    role: 'Founder, Urban Threads Apparel',
    image: 'https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'As an Amazon seller, protecting my brand was crucial. The team at Our Team handled everything from trademark registration to Brand Registry enrollment. Professional, fast, and affordable!'
  },
  {
    id: 4,
    name: 'David Chen',
    role: 'CTO, Innovate Labs',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Their patent services exceeded our expectations. The attorneys are knowledgeable, responsive, and truly care about protecting your innovations. We\'ve secured three patents with their help!'
  },
  {
    id: 5,
    name: 'Jennifer Lopez',
    role: 'Creative Director, Artisan Collective',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw1fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Copyright protection for our creative work was essential. The team handled everything efficiently, from registration to enforcement. Their expertise gave us peace of mind to focus on creating!'
  }
];

export const lpTestimonials = [
  {
    id: 1,
    name: 'Amanda R.',
    role: 'eCommerce Seller',
    content: 'Our Team made the whole process seamless! I got my approval in weeks and felt confident every step of the way.'
  },
  {
    id: 2,
    name: 'Michael T.',
    role: 'Tech Startup Founder',
    content: 'The attorneys were knowledgeable and responsive. They handled everything from search to filing. Highly recommend!'
  },
  {
    id: 3,
    name: 'Sarah L.',
    role: 'Small Business Owner',
    content: 'Transparent pricing and excellent service. They protected my Trademark Application Hub and helped me register on Amazon Brand Registry.'
  },
  {
    id: 4,
    name: 'James K.',
    role: 'Restaurant Owner',
    content: 'Outstanding service from start to finish. Their team guided me through every step and ensured my restaurant brand was fully protected.'
  },
  {
    id: 5,
    name: 'Emily W.',
    role: 'Fashion Designer',
    content: 'Professional and efficient! They secured my fashion brand trademark quickly and provided ongoing support. Couldn\'t be happier!'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: '98% Approval Success Rate',
    description: 'Industry-leading trademark approval rate backed by experienced IP attorneys and meticulous application preparation.',
    icon: 'Scale'
  },
  {
    id: 2,
    title: 'Licensed IP Attorneys',
    description: 'Every application reviewed and filed by USPTO-registered trademark attorneys specializing in brand protection.',
    icon: 'Users'
  },
  {
    id: 3,
    title: '24-48 Hour Filing',
    description: 'Fast-track your brand protection with expedited filing options and real-time application status tracking.',
    icon: 'Award'
  },
  {
    id: 4,
    title: 'Comprehensive Search',
    description: 'Thorough trademark clearance search across federal databases, state records, and common law sources.',
    icon: 'TrendingUp'
  }
];

export const whyChooseUsDetailed = [
  {
    id: 1,
    title: 'USPTO-Registered Attorneys',
    description: 'Licensed IP attorneys with 15+ years experience in federal trademark registration and brand protection law.',
    icon: 'Briefcase'
  },
  {
    id: 2,
    title: 'Transparent Flat-Rate Pricing',
    description: 'No hidden fees. Clear trademark registration packages from $45 with all costs disclosed upfront.',
    icon: 'DollarSign'
  },
  {
    id: 3,
    title: '24-48 Hour USPTO Filing',
    description: 'Fast-track your brand protection. We file trademark applications with USPTO within 24-48 hours.',
    icon: 'Zap'
  },
  {
    id: 4,
    title: 'Complete Trademark Protection',
    description: 'Full-service support from comprehensive trademark search through federal registration and ongoing monitoring.',
    icon: 'LifeBuoy'
  }
];

export const lpBenefits = [
  {
    id: 1,
    title: 'Legal Ownership',
    description: 'Prevent others from using your Trademark Application Hub or logo. Establish exclusive rights nationwide.',
    icon: 'Shield'
  },
  {
    id: 2,
    title: 'Brand Credibility',
    description: 'Build legal ownership and brand credibility that customers and investors trust.',
    icon: 'CheckCircle'
  },
  {
    id: 3,
    title: 'Amazon & eCommerce Protection',
    description: 'Protect your brand on Amazon, eCommerce platforms, and enroll in Amazon Brand Registry.',
    icon: 'ShoppingCart'
  },
  {
    id: 4,
    title: 'Federal Law Protection',
    description: 'Gain exclusive nationwide rights under federal law with USPTO registration.',
    icon: 'Flag'
  },
  {
    id: 5,
    title: 'Business Valuation',
    description: 'Increase your business\'s valuation and investor trust with registered IP assets.',
    icon: 'TrendingUp'
  },
  {
    id: 6,
    title: 'Legal Enforcement',
    description: 'Sue infringers and seek damages in federal court with registered trademark rights.',
    icon: 'Gavel'
  }
];

export const lpWhyTrust = [
  {
    id: 1,
    title: 'Experienced IP Attorneys',
    description: 'Decades of combined expertise in U.S. trademark law and intellectual property.',
    icon: 'Briefcase'
  },
  {
    id: 2,
    title: 'Fast Filing Process',
    description: 'Quick turnaround, status tracking, and 24-hour expedited options available.',
    icon: 'Clock'
  },
  {
    id: 3,
    title: 'Transparent Pricing',
    description: 'No hidden costs — clear and upfront fees with flat-rate pricing packages.',
    icon: 'DollarSign'
  },
  {
    id: 4,
    title: 'Full Legal Support',
    description: 'From search to registration to enforcement — complete trademark protection.',
    icon: 'Shield'
  }
];

export const howItWorks = [
  {
    id: 1,
    title: 'Free Trademark Consultation',
    description: 'Submit your brand details for a complimentary trademark evaluation. Our IP specialists assess your mark\'s registrability and identify potential conflicts within 24 hours.',
    icon: 'FileText'
  },
  {
    id: 2,
    title: 'Comprehensive Search & Attorney Review',
    description: 'Choose your protection package and we conduct an in-depth trademark search across USPTO databases, state records, and common law sources. Licensed attorneys review findings and prepare your application.',
    icon: 'CreditCard'
  },
  {
    id: 3,
    title: 'USPTO Filing & Ongoing Support',
    description: 'We file your trademark application with the USPTO and provide continuous monitoring. Track your application status online and receive expert support through approval and registration.',
    icon: 'CheckCircle'
  }
];

export const lpProcess = [
  {
    id: 1,
    title: 'Search & Review',
    description: 'We conduct a comprehensive trademark search and review to identify potential conflicts and ensure your brand is protected.',
    icon: 'Search'
  },
  {
    id: 2,
    title: 'Prepare & File',
    description: 'Our licensed attorneys prepare and file your complete USPTO trademark application with precision.',
    icon: 'FileCheck'
  },
  {
    id: 3,
    title: 'Approval & Protection',
    description: 'Track your application progress and receive your official trademark registration certificate from the USPTO.',
    icon: 'Award'
  }
];